var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 385,
    height: 393,
    viewBox: "0 0 385 393",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3070_3153)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.046 209.894H279.817V178.643H341.046V209.894ZM341.046 227.751H279.817V259.002H341.046V227.751ZM341.046 80.4265H279.817V111.677H341.046V80.4265ZM341.046 129.535H279.817V160.785H341.046V129.535ZM341.046 276.859H279.817V308.11H341.046V276.859ZM383.337 338.468C381.588 347.754 370.654 347.977 363.351 348.29H227.335V388.469H200.175L0 352.753V40.2922L201.357 4.53223H227.335V40.1133H358.671C366.063 40.4257 374.197 39.8899 380.626 44.3987C385.131 51.006 384.694 59.3995 385 66.9885L384.825 299.404C384.607 312.396 386.005 325.655 383.337 338.468ZM160.376 268.422C148.305 243.422 136.016 218.599 123.989 193.598C135.885 169.268 147.606 144.848 159.283 120.427C149.355 120.919 139.427 121.543 129.543 122.258C122.152 140.606 113.536 158.464 107.763 177.438C102.384 159.535 95.2552 142.303 88.7387 124.847C79.1167 125.383 69.4948 125.963 59.8735 126.543C70.0196 149.402 80.8229 171.946 90.663 194.938C79.0731 217.26 68.227 239.895 56.9868 262.35C66.5644 262.752 76.1428 263.154 85.7204 263.287C92.5436 245.52 101.028 228.421 106.976 210.295C112.312 229.76 121.364 247.752 128.8 266.368C139.34 267.128 149.836 267.797 160.376 268.422ZM364.141 61.3161H227.335V80.4265H262.323V111.677H227.335V129.535H262.323V160.785H227.335V178.643H262.323V209.894H227.335V227.751H262.323V259.002H227.335V276.859H262.323V308.11H227.335V328.756H364.141V61.3161Z",
    fill: "#2A292A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3070_3153"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 385,
    height: 393,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExcel);
export default __webpack_public_path__ + "static/media/IconExcel.645ffc4ce6e42a8e588280fdcd7ba81d.svg";
export { ForwardRef as ReactComponent };